import PropTypes from 'prop-types';
import React from 'react';

export default class Anchors extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'people', //表情
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const index = e.currentTarget.getAttribute('data-index');
    const { categories, onAnchorClick } = this.props;
    onAnchorClick(categories[index], index);
  }

  render() {
    const { categories, i18n } = this.props,
      { selected } = this.state;
    return (
      <nav
        className="flex justify-between h-[45px] bg-white2/90 rounded-b px-4 items-center w-full overflow-x-auto space-x-2"
        aria-label={i18n.categorieslabel}
      >
        {categories.map((category, i) => {
          const { id, anchor } = category,
            isSelected = id === selected;
          if (anchor === false) {
            return null;
          }

          const iconId = id.startsWith('custom-') ? 'custom' : id;
          return (
            <div
              key={id}
              data-index={i}
              aria-label={i18n.categories[iconId]}
              onClick={this.handleClick}
              title={i18n.categories[iconId]}
              className={`shrink-0 text-t2 cursor-pointer ${isSelected ? '' : 'text-grey4'}`}
            >
              {i18n.categories[iconId]}
            </div>
          );
        })}
      </nav>
    );
  }
}

Anchors.propTypes /* remove-proptypes */ = {
  categories: PropTypes.array,
  onAnchorClick: PropTypes.func,
  icons: PropTypes.object,
};

Anchors.defaultProps = {
  categories: [],
  onAnchorClick: () => {},
  icons: {},
};
